import React from "react";
import capgeminiLogo from "../../assets/capgemini.png";

const Header: React.FC = () => {
    return (
        <header
            className="
                fixed top-0 left-0 z-50
                w-full bg-[#EBF0FF]
                text-white
                py-4 px-6
                flex justify-between items-center
            "
        >
            <div className="w-[140px] sm:w-[180px] h-[36px] sm:h-[40px] shrink-0">
                <img
                    src={capgeminiLogo}
                    alt="Capgemini"
                    className="h-8 sm:h-10 w-auto object-contain"
                />
            </div>
        </header>
    );
};

export default Header;